/**
 * Función que retorna la posición de la ventana en X y Y.
 * @param {number} x 
 * @param {number} y 
 */
export function scrollTo(x, y) {
    return window.scrollTo(x, y);
}